<template>
  <b-modal v-model="show" title="Getting Started"
    :no-close-on-esc="true"
    :no-close-on-backdrop="true"
    :hide-header-close="true">
    <p>
      This OpenId Connect test client can be used to test the various authentication flows and inspect the content of jwt tokens.
    </p>
    <p>
      To use it you will need an OpenId Connect app setup in your OneLogin instance. When you are finished with
      this tool it is recommended that you generate a new client secret for your app.
    </p>
    <p>
      <ol>
        <li>Click on the Clients item in the top menu and enter the client Id and secret for your app.</li>
        <li>On the left hand side select the region for your OneLogin instance and the type of grant that you want to test.</li>
        <li>Click on the <b>Authenticate</b> button to start the flow.</li>
      </ol>
    </p>
    <p>Tokens, Codes and Errors will all be show in the Reponse area.</p>

    <b-alert variant="danger" show>
      <b>Disclaimer</b>
      <p>This app is purely for demonstrating the OIDC flows. </p>
      <p>
        To increase visibility, access token requests and
        secrets are being stored in client side javascript.
      </p>
      <p>We do not recommended that you do this with your own production applications.</p>
    </b-alert>

    <div slot="modal-footer" class="w-100">
      <b-btn size="sm" class="float-right" variant="primary" @click="hideHelp">
        Close
      </b-btn>
    </div>
  </b-modal>
</template>

<script>
export default {
  data () {
    return {
    }
  },

  props: ['show'],

  methods: {
    hideHelp: function () {
      this.$emit('hide')
    }
  }
}
</script>
<style>
</style>